// Configure Offset APIs
require("./offset.config.js");

/* Load Javascript */
//require('./jquery')
//require('./bootstrap')
//require('./figure')

// Offset Consent
const { ConsentManager, ConsentUI } = require("offset-consent");
(new ConsentUI(new ConsentManager(window.OFFSET.consent))).mount();
